import React from 'react'
import {
    Box,
    TextField,
    MenuItem,
    Alert,
    FormControl,
    FormControlLabel,
    Checkbox,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'
import {
    FormInputLabel,
    selectionControlSx,
    selectionControlLabelProps,
} from '@/shared/ui/input'
import { inputPaperSurface } from '@/shared/ui/input/inputVariants'
import { CompactButton } from '@/shared/ui/buttons'
import BlockTabQueries from '../../../../../Components/Admin/Pages/Blocks/BlockTabQueries'
import BlockFormTemplateSelect from '../../../../../Components/Admin/Pages/Blocks/BlockFormTemplateSelect'
import { BlockSettingsProps } from './types'

export const DashboardSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
    handleChangeState,
    handleTemplateOptionsChange,
    handleNormalChangeForSettings,
    handleChangeItem,
}) => {
    if (!state.item.defDossier)
        return <Alert severity="info">{kedo.t('Select an Entity first')}</Alert>

    return (
        <Box sx={{ mt: 2 }}>
            <Box sx={(theme) => inputPaperSurface(theme)}>
                <FormControl
                    fullWidth
                    size="small"
                    sx={{
                        flexDirection: 'row',
                        alignItems: 'flex-end',
                        mb: 2,
                    }}
                >
                    <Box sx={{ flexGrow: 1 }}>
                        <FormInputLabel className="required">
                            {kedo.t('View name')}
                        </FormInputLabel>
                        <TextField
                            select
                            size="small"
                            fullWidth
                            name="view_name"
                            value={state.item.settings.view_name || ''}
                            onChange={(e) =>
                                handleChangeSettings(
                                    'view_name',
                                    e.target.value
                                )
                            }
                        >
                            <MenuItem value="list">{kedo.t('List')}</MenuItem>
                            {state.views.map((displayView: any) => (
                                <MenuItem
                                    key={displayView.id}
                                    value={displayView.view_name}
                                >
                                    {displayView.view_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Box>
                    <CompactButton
                        onClick={() => handleChangeState('showAddView', true)}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </CompactButton>
                </FormControl>

                <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                    <FormInputLabel>{kedo.t('Limit')}</FormInputLabel>
                    <TextField
                        size="small"
                        fullWidth
                        name="limit"
                        type="number"
                        value={state.item.settings.limit}
                        onChange={(e) =>
                            handleChangeSettings(
                                'limit',
                                Number(e.target.value)
                            )
                        }
                    />
                </FormControl>

                <FormControlLabel
                    {...selectionControlLabelProps}
                    control={
                        <Checkbox
                            size="small"
                            checked={state.item.settings.show_add}
                            onChange={(e) =>
                                handleChangeSettings(
                                    'show_add',
                                    e.target.checked
                                )
                            }
                            sx={(theme) => selectionControlSx(theme)}
                        />
                    }
                    label={kedo.t('Show add buttons')}
                    sx={{ ...selectionControlLabelProps.sx, mt: 1, mb: 2 }}
                />
            </Box>

            <BlockTabQueries
                kedo={kedo}
                tabQueries={state.item.settings.tabQueries}
                dossierQueries={state.dossierQueries}
                addTabQuery={() => {
                    const newTabQueries = Array.isArray(
                        state.item.settings.tabQueries
                    )
                        ? [...state.item.settings.tabQueries]
                        : []
                    newTabQueries.push({ query: null, title: '' })
                    handleChangeSettings('tabQueries', newTabQueries)
                }}
                onChangeTabQueries={(
                    item: any,
                    i: number,
                    name: string,
                    value: any
                ) => {
                    const tabQueries = [...state.item.settings.tabQueries]
                    tabQueries[i] = { ...tabQueries[i], [name]: value }
                    handleChangeSettings('tabQueries', tabQueries)
                }}
                deleteTabQuery={(i: number) => {
                    const tabQueries = [...state.item.settings.tabQueries]
                    tabQueries.splice(i, 1)
                    handleChangeSettings('tabQueries', tabQueries)
                }}
            />
            <BlockFormTemplateSelect
                handleTemplateOptionsChange={handleTemplateOptionsChange}
                layout={state.item.settings.layout}
                view_name={state.item.settings.view_name}
                template={state.item.settings.template}
                templateOptions={state.item.settings.templateOptions}
                defDossier={state.item.defDossier}
                handleNormalChange={handleNormalChangeForSettings}
                handleChangeVar={handleChangeItem}
                kedo={kedo}
            />
        </Box>
    )
}
